import { render, staticRenderFns } from "./BudgetsManagement.vue?vue&type=template&id=59d01508"
import script from "./BudgetsManagement.vue?vue&type=script&lang=js"
export * from "./BudgetsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports